import type { Styles } from '@adornis/ass/style.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import { examTypeBadge } from '@ils/examType/client/examTypeBadge.js';
import { badgeStyleNeutralSm, badgeStylePositiveSm } from '@ils/theme/badges.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { ExamDay } from '../../db/examdays.js';

/**
 * @element ils-examday-select-item
 */
@customElement('ils-examday-select-item')
export class ILSExamDaySelectItem extends ChemistryLitElement {
  @property({ type: Boolean, attribute: 'single-line' }) singleLine = false;
  @property({ attribute: false }) examDay!: ExamDay;

  override render() {
    if (Array.isArray(this.examDay.candidateIDs) && this.examDay.maxCandidates) {
      const freeSlots = this.examDay.maxCandidates - this.examDay.candidateIDs.length;

      const name = this.singleLine
        ? html` <x-text>${this.examDay.name}</x-text> `
        : html`
            <x-flex space="xs" flex>
              <x-text>${this.examDay.name}</x-text>
              <x-text tone="subtle"> ${this.examDay.location?.displayName ?? '---'} </x-text>
            </x-flex>
          `;
      const typeBadge = examTypeBadge(this.examDay.examType, null, true);
      if (freeSlots === 0) {
        return html`
          <x-flex horizontal w100 crossaxis-center space="sm">
            ${name} ${typeBadge} <x-text ${css(badgeStyleNeutralSm())}> Belegt </x-text>
          </x-flex>
        `;
      } else {
        return html`
          <x-flex horizontal w100 crossaxis-center space="sm">
            ${name} ${typeBadge}
            <x-text ${css(badgeStylePositiveSm())}> ${freeSlots} ${freeSlots <= 1 ? 'Platz' : 'Plätze'} frei </x-text>
          </x-flex>
        `;
      }
    } else {
      return this.examDay.name;
    }
  }

  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        ':host': this.singleLine
          ? {}
          : {
              display: 'block',
              padding: this.spacing.sm,
            },
      },
    ];
  }
}
